class AbstractClass {
    constructor() {
        if (new.target === AbstractClass) {
            throw new TypeError("Cannot instantiate abstract class directly.");
        }
        this.#validateAbstractMethods();
    }

    // List abstract methods that subclasses must implement
    static abstractMethods() {
        return [];
    }

    #validateAbstractMethods() {
        console.log(`Validating abstract methods for ${this.constructor.name}`);
        const requiredMethods = this.constructor.abstractMethods();

        requiredMethods.forEach(method => {
            const prototypeMethod = Object.getPrototypeOf(this)[method];

            if (
                typeof this[method] !== "function" || 
                prototypeMethod === AbstractClass.prototype[method] ||  // Not overridden
                prototypeMethod === Object.getPrototypeOf(this.constructor.prototype)[method] // Inherited but not overridden
            ) {
                throw new Error(`Method '${method}' must be implemented in ${this.constructor.name}`);
            }
        });
    }
}

export default AbstractClass;